import ConfirmModifyCommitContainer from './ConfirmModifyCommitContainer';

export default ConfirmModifyCommitContainer;
